import { CoursesCatalogActions } from "./CoursesCatalog-slice";
import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchCatalogSearchData = (url_data, token) => {
	// console.log(url_data)
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const catalogData = await fetchData();
			dispatch(CoursesCatalogActions.updateCatalogSearchData(catalogData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const fetchCatalogData = (url_data, token) => {
	// console.log(url_data)
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(10));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const catalogData = await fetchData();
			dispatch(CoursesCatalogActions.updateCatalogData(catalogData));
			dispatch(uiActions.hideLoadingSpinner(10));
		} catch (error) {
			console.log(error);
		}
	};
};
